import pluralize from 'pluralize';
import React from 'react';
import { TemplateBuilderContainer } from './Components/TemplateBuilderContainer';
import {
  TemplateBuilder,
  TemplateBuilderFactory,
} from './Components/TemplateBuilderFactory';
import { TemplateBuilderInputTriggerSection } from './Components/TemplateBuilderInputTriggerSection';
import { TemplateBuilderReengagementSection } from './Components/TemplateBuilderReengagementSection';
import { TemplateSubsectionLink } from './Components/TemplateSubsectionLink';

export const LongestFollowUpFunnelBuilder: TemplateBuilder = ({
  maxFollowUpCounts,
}) => {
  return (
    <TemplateBuilderFactory
      template="longest_follow_up_funnel"
      {...maxFollowUpCounts}
    >
      {props => (
        <TemplateBuilderContainer
          enabled={!props.busy && props.isValid}
          confirm={props.confirm}
        >
          <TemplateBuilderInputTriggerSection>
            <div>
              On {props.channelName}, when someone {props.triggersSelect}, send{' '}
              {props.channelMessageName} to attempt to collect their{' '}
              {props.collectionSelect}, then ask them{' '}
              {props.qualifyingQuestionSelect}.
            </div>
          </TemplateBuilderInputTriggerSection>
          <TemplateSubsectionLink />
          <TemplateBuilderReengagementSection>
            <div>
              Using the data collected from {props.channelName}, if the lead is
              qualified (a Unicorn!) send them a {props.unicornEmailSelect}{' '}
              email and {props.unicornSMSSelect} SMS text message re-engagement
              sequence over{' '}
              {Math.max(props.unicornSMSQuantity, props.unicornEmailQuantity)}{' '}
              {pluralize(
                'day',
                Math.max(props.unicornSMSQuantity, props.unicornEmailQuantity),
              )}
              . If someone is not qualified (a Donkey) send them a{' '}
              {props.donkeySMSSelect} text message and {props.donkeyEmailSelect}{' '}
              email informational sequence to build brand affinity.
            </div>
          </TemplateBuilderReengagementSection>
        </TemplateBuilderContainer>
      )}
    </TemplateBuilderFactory>
  );
};
